import { cn } from '@/shared/lib/utils';
import { useTracking } from '@/modules/analytics/hooks/use-tracking';

export type FooterProps = {
  className?: string;
};

export function Footer({ className }: FooterProps) {
  const { pratigoFooterClick } = useTracking();

  const handlePratigoClick = () => {
    pratigoFooterClick(window.location.origin);

    const referrerUrl = window.location.origin;
    const pratigoUrl = `https://pratigo.com.br?utm_source=${encodeURIComponent(referrerUrl)}`;

    window.open(pratigoUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <footer className={cn('w-full bg-white border-t border-gray-100 py-4 mt-3', className)}>
      <div className="flex items-center justify-center">
        <button
          onClick={handlePratigoClick}
          className="flex items-center gap-2 text-gray-600 hover:text-gray-800 transition-colors duration-200 group"
        >
          <span className="text-sm font-medium">Um produto</span>
          <div className="flex items-center gap-1">
            <span className="text-sm font-semibold text-primary">pratiGO</span>
            <span className="text-sm font-medium">®</span>
          </div>
        </button>
      </div>
    </footer>
  );
}
